var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKibbcomlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 187,
    viewBox: "0 0 201 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H59V73.5875L24 107V26Z",
    fill: "#007AFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 125L98.0001 101L155.227 164H109.226L72 125Z",
    fill: "#007AFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.342 26.1221H162.5L24 164L24.0004 116L114.342 26.1221Z",
    fill: "#007AFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKibbcomlogo);
export default __webpack_public_path__ + "static/media/Kibbcomlogo.06b643ab4b95b33eb18d62acccc9a6f4.svg";
export { ForwardRef as ReactComponent };